import React, { useEffect } from 'react'
import HeroSection from './HeroSection/HeroSection'
import AboutSection from './AboutSection/AboutSection'
import CapabilitiesSection from './CapabilitiesSection/CapabilitiesSection'
import ServiceArea from './ServiceArea/ServiceArea'
import MarketsServed from './MarketsServed/MarketsServed'
// import FeaturedProjects from '../Common/FeaturedProjects/FeaturedProjects'
import ProjectStats from '../Common/ProjectStats/ProjectStats'
import TestimonialSlider from '../Common/TestimonialSlider/TestimonialSlider'
import FeaturedGallery from '../pages/ImageGallery/FeaturedGallery'

function Home() {
  return (
    <div>
        <HeroSection/>
        <AboutSection />
        <CapabilitiesSection />
        <ServiceArea/>
        <FeaturedGallery />
        <MarketsServed />
        <ProjectStats/>
        <TestimonialSlider/>
    </div>
  )
}

export default Home
